<template>
    <b-table
        :data="permissionsDisplay"
        class="no-wrap is-clipped ellipsis"
        checkable
        :checked-rows.sync="checkedPermissions"
        :is-row-checkable="(row) => !checkboxDisabled || isSuperAdmin"
        :loading="loading"
    >
        <template slot-scope="props">
            <b-table-column field="name" label="Check All" style="width:50%;">
                {{ props.row.name }} 
                <template v-if="isSuperAdmin">
                    <button 
                    :class="'button is-small' + (isSystem(props.row) ? ' is-info' : '')"
                    style="float:right;"
                    @click="toggleTag(props.row, $event)"
                    >
                        SYSTEM
                    </button>
                </template>
            </b-table-column>
            <b-table-column field="notes" label="Notes">{{ props.row.notes }}</b-table-column>
        </template>
    <!-- {{ permissionsDisplay }} -->
    </b-table>
</template>
<script>
import { systemTagMixin } from '@/mixins/systemTagMixin';
import { PermissionService } from "@/services/permission.service";
import { RoleService } from "@/services/role.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
export default {
    mixins: [ systemTagMixin ],
    props: {
        role: {
            type: Object,
            default: () => {}
        },
        params: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: () => null
        },
        nativeRoles: {
            type: Array,
            default: () => {}
        }
    },
    data: () => ({
        permissionService: PermissionService,
        roleService: RoleService,
        permissions: [],
        checkedPermissions: [],
        loading: false,
        rolePreviousValue:{},
        openConfirm: true,
    }),
    computed: {
        checkboxDisabled() {
            return this.nativeRoles.find(element => element.id == this.role.id && element.tags.length && element.tags[0].pivot.archived_at == null);
        },
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"]('superadmin');
        },
        permissionsDisplay() {
            if (this.isSuperAdmin) {
                return this.permissions;
            }else{
                let permissionIds = this.nativeData.filter(element => {
                    let x = true;
                    if (element.tags.length) {
                        let tag = element.tags.find(element => element.type == '[SYSTEM]' && element.name.toUpperCase() == 'SYSTEM');
                        x = tag && tag.pivot.archived_at != null;
                    }
                    return x;
                }).map(element => element.id);
                if (permissionIds.length) {
                    return this.permissions.filter(element => {
                        return permissionIds.includes(parseInt(element.id));
                    });
                }
            }
        }
    },
    watch: {
        "role.id"(a, b) {

            this.rolePreviousValue = b;
            
            const permids = this.role.permissions.map(a => a.id);
            this.checkedPermissions = this.permissions.filter(permission => {
                return permids.includes(permission.id);
            });
        },
        checkedPermissions: {
            handler(value, previousValue) {

                // validate if selected role change permission

                if (this.rolePreviousValue && this.rolePreviousValue == this.role.id && this.openConfirm) {
                    
                    this.confirm(value, previousValue);

                    return;

                }

                // Set rolePreviousValue to current / Necessary validations

                this.openConfirm = true;

                this.rolePreviousValue = this.role.id;

                // 

                if ( this.checkedPermissions.length != this.role.permissions.length ) {
                    this.syncPermissions();
                }
            },
            deep: true
        }
    },

    mounted() {
        this.getTags();
        this.fetchPermissions();
    },
    methods: {
        async fetchPermissions() {
            this.loading = true;
            const response = await this.permissionService.all(this.params);
            this.loading = false;
            this.permissions = JsonDenormalizer.denormalize(response);
        },
        async syncPermissions() {
            this.loading = true;
            const data = {
                permission_ids: this.checkedPermissions.map(a => a.id)
            };
            const response = await this.roleService.syncPermissions(
                this.role.id,
                data
            );
            this.loading = false;
            const role = JsonDenormalizer.denormalize(response);
            this.$parent.permissionUpdated(role);
        },

        confirm(value, previousValue) {
            let message = '';

            if (previousValue.length - value.length < -1) {

                message = 'This action will \'assign all permission\' for every user who is assigned the \''+ this.role.name +'\' role.';

            } else if(previousValue.length - value.length > 1){
                
                message = 'This action will \'remove all permission\' for every user who is assigned the \''+ this.role.name +'\' role.';

            } else if (value.length > previousValue.length) {

                message = 'This action will assign \''+ value[value.length - 1].name +'\' permission to every user who is assigned the \''+ this.role.name +'\' role';
            
            } else {
            
                message = 'This action will unassign \''+ previousValue[previousValue.length - 1].name +'\' permission to every user who is assigned the \''+ this.role.name +'\' role';
            }

            this.$buefy.dialog.confirm({
                title: "Confirm",
                message: message,
                confirmText: "Confirm",
                type: "is-danger",
                hasIcon: true,
                onConfirm: () => {
                    this.syncPermissions();
                },
                onCancel: () => {
                    this.checkedPermissions = previousValue;
                    this.openConfirm = false;
                }
            });
        },
        async toggleTag(row, event) {
            await PermissionService.toggleTag({id: row.id}).then(response => {
                this.$buefy.toast.open({
                  message: "Success",
                  type: "is-success",
                  position: "is-top-right"
                });       
            });
            event.target.classList.toggle('is-info')
        },
        async getTags() {
            await PermissionService.getTags().then(response => {
                this.nativeData = response;
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Roles/partials/permissionTable.vue